import { CustomerUserTypeSchema, UserStatusSchema } from '../../entities/user/user.schema';
/**
 * The statuses that carry a login: 'active' signs in, 'pending' activates on
 * first login. Lives beside `seatPoolsForRoles` because the two together define
 * a seat — the backend's Mongo pool filters and the frontend's member read must
 * select the same people, or a seat that causes an overrun is invisible to the
 * page that repairs it.
 */ export const SIGN_IN_ELIGIBLE_USER_STATUSES = Object.freeze([
    UserStatusSchema.enum.active,
    UserStatusSchema.enum.pending
]);
/** The pools a user with these roles occupies. */ export function seatPoolsForRoles(userTypes) {
    const rolePools = CustomerUserTypeSchema.options.filter((role)=>userTypes.includes(role));
    return rolePools.length > 0 ? [
        ...rolePools
    ] : [
        'member'
    ];
}

//# sourceMappingURL=seat-pools.js.map